import React, { useState } from "react";
import api from "@/lib/api";
import { Mail, X, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function EmailDocButton({ endpoint, testid, label = "Email", className = "" }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (to) => {
    setBusy(true);
    try {
      const payload = { origin_url: window.location.origin };
      if (to) { payload.to = to; payload.save_to_contact = true; }
      const { data } = await api.post(endpoint, payload);
      toast.success(`Emailed to ${data.to}`);
      setOpen(false); setEmail("");
    } catch (e) {
      const detail = e.response?.data?.detail || "";
      if (!to && /no customer email/i.test(detail)) setOpen(true);
      else toast.error(detail || "Email failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid={testid} onClick={() => send()} className={className} title="Email to customer">
        <Mail className="w-3.5 h-3.5" /> {label}
      </button>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50" onClick={() => setOpen(false)}>
          <div className="mb-card p-6 w-full max-w-sm animate-scale-in" onClick={(e) => e.stopPropagation()} data-testid="email-prompt-modal">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-display text-lg font-bold uppercase text-navy">Add customer email</h3>
              <button onClick={() => setOpen(false)}><X className="w-5 h-5 text-slate-400" /></button>
            </div>
            <p className="text-xs text-slate-500 mb-3">This customer has no email on file. Enter one to send now — we'll save it to their record.</p>
            <input data-testid="email-prompt-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="customer@email.com"
              className="w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-navy mb-4" autoFocus />
            <button data-testid="email-prompt-send" onClick={() => { if (!/.+@.+\..+/.test(email)) return toast.error("Enter a valid email"); send(email); }} disabled={busy}
              className="w-full bg-brandred text-white font-bold py-3 rounded-xl border-2 border-brandred flex items-center justify-center gap-2 active:translate-y-px disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send &amp; Save
            </button>
          </div>
        </div>
      )}
    </>
  );
}
